import { Box, Stack, Text } from '@chakra-ui/react';

import { useGetPublicImage } from '@/client/services/hooks/media/useGetPublicImage';
import { useTranslation } from 'react-i18next';

export default function AiAgentAdminDashboardHero() {
  const { t } = useTranslation();
  const { getPublicImage } = useGetPublicImage();

  return (
    <Box
      backgroundColor="#171717"
      borderRadius="12px"
      padding={10}
      backgroundImage={getPublicImage('continu/app-images/eddy-banner.jpg')}
      backgroundSize="cover"
      backgroundPosition="center center"
    >
      <Stack>
        <Text fontSize="24px" fontWeight={500} color="white" maxWidth="300px">
          {t('admin.aiAgent.dashboard.hero.title')}
        </Text>

        <Text fontSize="14px" fontWeight={500} color="whiteAlpha.600" maxWidth="400px">
          {t('admin.aiAgent.dashboard.hero.description')}
        </Text>
      </Stack>
    </Box>
  );
}
